import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en";

const resources = {
  en: {
    translation: en,
  },
};

const options = {
  order: ["navigator"],
  lookupQuerystring: "lng",
};

i18n.use(initReactI18next).init({
  detection: options,
  resources,
  lng: "en",
  fallbackLng: "en",
  debug: false,
  keySeparator: ".",
  interpolation: {
    escapeValue: false,
  },

  react: {
    useSuspense: true,
  },
});

export default i18n;
